import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableCell, TableRow } from '@material-ui/core';

const DataTableBody = (props) => {
  return (
    <TableBody>
      {props.data.map((currentRowObject, index) => (
        <TableRow hover tabIndex={-1} key={index}>
          {props.accessorFunctions.map((currentAccessor, index) => {
            const cellObject = currentAccessor(currentRowObject);
            return (
              <TableCell
                key={index}
                padding="default"
                style={cellObject.style}
                className={cellObject.className}
                align={cellObject.isNumeric ? 'right' : 'inherit'}
                onClick={
                  cellObject.ignoreOnClick
                    ? undefined
                    : currentRowObject.onClick
                }
              >
                {cellObject.display}
              </TableCell>
            );
          })}
        </TableRow>
      ))}
    </TableBody>
  );
};

DataTableBody.propTypes = {
  data: PropTypes.array.isRequired,
  accessorFunctions: PropTypes.array.isRequired
};

export default DataTableBody;
